import React, { PureComponent } from 'react';
import { Link as RouterLink } from 'react-router-dom';

class Link extends PureComponent {
  render() {
    const { text, style, onClick, to, className } = this.props;
    if (to)
      return (
        <RouterLink
          className={`component-link ${className}`}
          style={style}
          to={to || null}
        >
          {text}
        </RouterLink>
      );

    return (
      <span
        className={`component-link ${className}`}
        style={style}
        onClick={onClick}
      >
        {text}
      </span>
    );
  }
}

export default Link;
